/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createGcd } from '../../factoriesNumber.js';
export var gcdDependencies = {
  typedDependencies,
  createGcd
};